var T = Object.defineProperty, g = Object.defineProperties;
var C = Object.getOwnPropertyDescriptors;
var u = Object.getOwnPropertySymbols;
var M = Object.prototype.hasOwnProperty, R = Object.prototype.propertyIsEnumerable;
var w = (o, e, r) => e in o ? T(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, n = (o, e) => {
  for (var r in e || (e = {}))
    M.call(e, r) && w(o, r, e[r]);
  if (u)
    for (var r of u(e))
      R.call(e, r) && w(o, r, e[r]);
  return o;
}, f = (o, e) => g(o, C(e));
import { jsxs as y, jsx as k } from "react/jsx-runtime";
import p from "../../../node_modules/prop-types/index.es.js";
import { useState as l, useEffect as P } from "react";
import { usePopper as q } from "react-popper";
import * as z from "./style.es.js";
import { Dropdown as N, DropdownPopper as $, DropdownPopperArrow as B } from "./style.es.js";
import { useOutsideClick as F } from "../../../hooks/useOutsideClick.es.js";
const i = ({
  children: o = () => null,
  dropdownOptions: e = {
    hasPopperArrow: !1
  },
  isMenuOpenDefault: r = !1,
  popperOptions: b = {
    placement: "bottom",
    strategy: "fixed"
  },
  style: E,
  popperStyles: h,
  referenceComponent: j = () => null
}) => {
  const [t, s] = l(r), [c, x] = l(null), [A, D] = l(null), [O, I] = l(null), {
    styles: d,
    attributes: S,
    update: m
  } = q(c, A, n(f(n({}, b), {
    strategy: "fixed"
  }), e.hasPopperArrow ? {
    modifiers: [{
      name: "arrow",
      options: {
        element: O
      }
    }]
  } : {}));
  return F({
    current: c
  }, () => s(!1)), P(() => {
    s(r);
  }, [r]), P(() => {
    m && m();
  }, [t, m]), /* @__PURE__ */ y(N, { ref: x, style: E, children: [
    j({
      setIsMenuOpen: (a) => {
        s(a || !t);
      },
      isMenuOpen: t
    }),
    /* @__PURE__ */ y($, f(n({ ref: D, style: d.popper }, S.popper), { isMenuOpen: t, popperStyles: h, children: [
      o({
        setIsMenuOpen: s,
        isMenuOpen: t
      }),
      e.hasPopperArrow && /* @__PURE__ */ k(B, { ref: I, style: d.arrow })
    ] }))
  ] });
}, G = {
  children: p.func.isRequired,
  dropdownOptions: p.object,
  isMenuOpenDefault: p.bool,
  popperOptions: p.object,
  popperStyles: p.object,
  style: p.object,
  referenceComponent: p.func,
  zIndex: p.number
};
i.S = z;
i.displayName = "Dropdown";
i.propTypes = G;
export {
  i as Dropdown,
  G as dropdownPropTypes
};
//# sourceMappingURL=Dropdown.es.js.map
